import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance,{fetchInstance} from '../../helper/axios'
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import { baseUrl } from '../../config';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { clickColor, inArray } from './../../library/util';
import Loader from "react-loader-spinner";
function Affilates() {

  const history = useHistory();
  checkUserTypeFn(history);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loader, setLoader] = useState(false)

  const [selectedrowList, setSelectedRowList] = useState([]);
  const [resultCount, setResultCount] = useState(0);
  const [resultCountCounter, setResultCountCounter] = useState(0);


  const setRowBackground = (selectedRow) => {
    if (inArray(selectedRow.tableData.id, selectedrowList) == false) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }


  function checkUserTypeFn(history) {
    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const usertype = userdata.type;
    console.log('in check usertype fn');
    console.log(usertype)
    if (usertype != 'admin' && usertype != 'superadmin' && usertype != 'subadmin' && usertype != 'databasehelper' && usertype != 'owneradmin') {
      history.push('/');
    }

  }
  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null) {
    history.push('/');
  }

  const [midData, setMidData] = useState([])

  const [message, setMessage] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];
  const [successMsg, setSuccessMsg] = useState('')
  useEffect(() => {
    setLoader(true)
    axiosIntance.get(baseUrl + '/count/affiliates', {}).then(response => {
      setResultCount(response.data.result);
      setResultCountCounter(1);
      setLoader(false)
    }).catch(error => {
      console.log(error)
      setMessage('Something went wrong');
    });
    return () => {
      console.log('un subscribe')
    }

  }, [])


  const SubmitDelete = (e) => {

    confirmAlert({
      title: '',
      message: 'Are you sure want to delete All data',
      buttons: [
        {
          label: 'Yes',
          onClick: () =>
            axiosIntance.delete(baseUrl + '/affiliates', {}).then(response => {
              setSuccessMsg('Deleted!')
            }).catch(error => {
              setMessage('Something went wrong');
            })

        },
        {
          label: 'No',
          onClick: () => console.log('No')
        }
      ]
    });
  }



  return (

    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

      <div className='delete-div'>
        {
          midData.length > 0 ? <button type="button" onClick={SubmitDelete} className="btn btn-primary">Delete All </button> : ''

        }

      </div>
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>

      <section id="content-wrapper">

        {loader &&
          <div className='loaderDiv'>
            <Loader
              type="Circles"
              color="#b4d6fa"
              height={100}
              width={100}
            />
          </div>
        }


        {resultCountCounter > 0 &&
          <MaterialTable

            onRowClick={((evt, selectedRow) =>
              setRowBackground(selectedRow)
            )}

            columns={[
              { title: "Advertiser.ID", field: "advertiser_id" },

              { title: "Advertiser.Name", field: "advertiser_name" },
              { title: "Affiliate.ID", field: "affiliate_id" },
              { title: "Affiliate.Name", field: "affiliate_name" },
              { title: "Offer.ID", field: "offer_id" },
              { title: "Offer.Name", field: "offer_name" },
              { title: "AM.ID", field: "am_id" },
              { title: "Account.Manager", field: "account_manager" },
              { title: "Status", field: "status" },
              { title: "Date.Added", field: "date_added" },
              { title: "Present.CPA", field: "present_cpa" },
              { title: "Effective.CPA.Date", field: "effective_date" },
              { title: "Past.Custom.Cpa", field: "past_custom_cpa" },
              { title: "Past.Custom.Date", field: "past_custom_date" },
              { title: "Is.Scheduler", field: "is_scheduler" },


            ]}
            data={query =>
              new Promise((resolve, reject) => {

                let url = baseUrl + '/affiliates?'
                url += `&_page=${query.page + 1}`
                url += `&_limit=${query.pageSize}`
                fetchInstance(url)
                  .then(response => response.json())
                  .then(result => {
                    resolve({
                      data: result.result,
                      page: query.page,
                      totalCount: resultCount,
                    })
                  })
              })
            }
            options={{
              maxBodyHeight: '500px',
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
              })
            }}
            title="Affiliates Data"
          />
        }
      </section>
    </div>
  )
}

export default Affilates